/*jshint esversion: 9 */
import store from '@/store/index';
import { mapGetters, mapActions, mapState } from 'vuex';
export const ProjectMixin = {
  computed: {
    ...mapGetters('Project', [
      'getOwnTWorkPackages',
      'getProjectLength',
      'getProjectStart',
      // 'getProjectInformation',
      'getStatisticsTrainSelector',
      'getStatisticsMilestoneSelector',
      'getStatusArray',
      'getFullStatusArray',
      'isEditMode',
      'isInsertingTrain',
      'isShowStatusBadges',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCalendar',
      'getCurrentTaktIndex',
      'getCurrentDayIndex',
      'isShowCalendarWeeks',
      'getRegularWeek',
      'getWeekDays',
      'getFirstDayOfWeek',
      'getFirstDayOfWeekInteger',
      'getMonths',
      'getNewDate',
      'getFreeDays',
      'getCollisionWeeks',
      'getGridSections'
    ]),
    ...mapGetters('ProjectStatistics', [
      'getStatistics',
      'getStatisticSettings',
    ]),
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObjectParent',
      'getUObject'
    ]),
    ...mapGetters('ProjectMilestone', [
      'getMileStones',
      'getPMileStones',
      'getNewPMilestone',
      'getElementsIndexAndLocation',
    ]),
    ...mapGetters('View', [
        'getSnackBar',
        'isShowOwnWps',
        'isShowMilestones',
        'isSpatialView'
    ]),
    ...mapGetters('SnackBar', [
      'getAffectedTargets'
    ]),
    ...mapGetters('Auth', [
      'isLoggedIn',
      'isCloudPrint'
    ]),
    ...mapState('ProjectCalendar', [
      'working_time'
    ])
  },
  methods: {
    ...mapActions('Project', [
      'leaveEditMode',
      // 'trainChangePosition',
      'trainDelete',
    ]),
    ...mapActions('ProjectStatistics', [
      'setStatisticSettings',
      'resetStatisticSettings',
      'resetFilter'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbar',
      'requestSnackbarCreate',
      'requestSnackbarUpdatePosition',
      'requestSnackbarUpdateParent',
      'requestSnackbarDelete',
      'updateSnackbar',
      'applySnackbar',
      'applySnackbarCreateElements',
      'applySnackbarUpdateElements',
    ]),
    ...mapActions('SnackBarIFC', {
      updateSnackbarIFC: 'updateSnackbar',
      applySnackbarIFC: 'applySnackbar',
    }),
    ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'updateUObjectPosition',
      'updateUObjectParent',
      'requestUObject'
    ]),
    ...mapActions('UltraDev', [
      'createUDObject',
      'updateUDObject',
      'deleteUDObject',
    ]),
    ...mapActions('ProjectCalendar', [
      'setCalendar',
      'deleteFreeDay',
      'resetCalendar',
      'setDayCollisionWeek',
      'setFirstDayOfWeek',
      'setFreeDay',
      'setProjectStart',
      'setShowCalendarWeeks',
      'setTaktTime',
      'setTaktStart',
      'setWorkingTime'
    ]),
    ...mapActions('View', [
      'setSnackBarCheckOldValue',
      'closeSnackBar',
      'setShowMilestones',
      'setSpatialView',
      'toggleTaktplanMilestonesView'
    ]),
    getAllowedProjectStarts(val) {
      return this.getRegularWeek(this.project_id).find(day => day.name === this.getWeekDays[this.getNewDate(val).getDay()]).selected;
    },
    snackBarBulk() {
      store.dispatch(`${this.getSnackBar.action.path}`, this.getSnackBar.action.payload);
      this.closeSnackBar();
    },
    routeToTaktplan() {
      // check if current rout is already ProjecTaktPlan
      if (this.$route.name === 'ProjectTaktPlan') {
        // if yes, then do nothing
        return;
      }
      this.$router.push({ name: 'ProjectTaktPlan' });
    },
  }
};
